import React from "react";
import PropTypes from "prop-types";
import "./statusMetricBlockV2.scss";

/**
 * StatusMetricBlockV2 Component
 *
 * V2 design: light tinted background card with a small status pill.
 * Used in CarePlanV2 collapsible sections.
 */
const StatusMetricBlockV2 = ({
  label,
  value,
  status,
  unit,
  className = "",
}) => {
  const getStatusClass = (s) => {
    if (!s) return "default";
    if (s === "poor" || s === "high") return "poor";
    if (s === "fair" || s === "moderate" || s === "elevated") return "fair";
    if (s === "good" || s === "low") return "good";
    if (s === "no_data" || s === "offline") return "no-data";
    return "default";
  };

  const statusClass = getStatusClass(status);

  return (
    <div className={`smb2 smb2--${statusClass} ${className}`}>
      <div className="smb2__label">{label}</div>
      <div className="smb2__value-row">
        <span className={`smb2__pill smb2__pill--${statusClass}`}>{value}</span>
        {unit && <span className="smb2__unit">{unit}</span>}
      </div>
    </div>
  );
};

StatusMetricBlockV2.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  status: PropTypes.string,
  unit: PropTypes.string,
  className: PropTypes.string,
};

export default StatusMetricBlockV2;
